import { HyperBackendMethod } from "@shared/backend/hyper-backend-method";
import { pick } from "lodash";
import { Allow, Controller, repo } from "remult";
import type { AvailabilityBase } from "../availability-base";
import { OpportunityAvailability } from "./entity";

@Controller("opportunity-availability-methods")
export class OpportunityAvailabilityMethods {
  @HyperBackendMethod({
    apiPrefix: "opportunity-availability-methods",
    allowed: Allow.authenticated,
    overrideSecurity: true,
  })
  static async replaceAll(
    opportunityId: string,
    availability: AvailabilityBase[],
  ) {
    await repo(OpportunityAvailability).deleteMany({
      where: {
        opportunityId,
        dow: {
          $in: availability?.map((v) => v.dow),
        },
      },
    });

    return await repo(OpportunityAvailability).insert(
      availability?.map((v) => ({
        ...v,
        opportunityId,
      })),
    );
  }

  @HyperBackendMethod({
    apiPrefix: "opportunity-availability-methods",
    allowed: Allow.authenticated,
    overrideSecurity: true,
  })
  static async updateOne(
    opportunityId: string,
    availability: AvailabilityBase,
  ) {
    return await repo(OpportunityAvailability).updateMany({
      where: {
        opportunityId,
        dow: availability.dow,
      },
      set: pick(availability, "MORNING", "AFTERNOON", "EVENING"),
    });
  }

  @HyperBackendMethod({
    apiPrefix: "opportunity-availability-methods",
    allowed: Allow.authenticated,
    overrideSecurity: true,
  })
  static async create(opportunityId: string, availability: AvailabilityBase[]) {
    return await repo(OpportunityAvailability).insert(
      availability?.map((v) => ({
        ...v,
        opportunityId,
      })),
    );
  }
}
